module.exports = __webpack_public_path__ + "static/img/t29.fda2abb9.png";